// extracted by mini-css-extract-plugin
export default {"root":"VgW_uAbUXb"};